import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { saveToIndexedDB, syncDataToServer } from "../../utils/storage";
import { CartItem } from "./cartSlice";

export interface Order {
  id: string;
  date: string;
  items: CartItem[];
  subtotal: number;
  discount: number;
  total: number;
  status: "Processing" | "Shipped" | "Delivered" | "Cancelled";
  shippingAddress: {
    address: string;
    city: string;
    zipCode: string;
  };
}

interface OrderState {
  orders: Order[];
}

const initialState: OrderState = {
  orders: [],
};

const orderSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    syncOrders: (state, action: PayloadAction<Order[]>) => {
      state.orders = action.payload;
    },
    addOrder: (
      state,
      action: PayloadAction<{ order: Order; email: string }>,
    ) => {
      const { order, email } = action.payload;
      state.orders.unshift(order); // Newest first
      if (typeof window !== "undefined") {
        saveToIndexedDB(`nakman_orders_${email}`, state.orders);
        syncDataToServer(email, { orders: state.orders });
      }
    },
    resetOrders: (state) => {
      state.orders = [];
    },
  },
});

export const { syncOrders, addOrder, resetOrders } = orderSlice.actions;
export default orderSlice.reducer;
